import { render, staticRenderFns } from "./QuestionPaperDetail.vue?vue&type=template&id=beea03be&scoped=true&"
import script from "./QuestionPaperDetail.vue?vue&type=script&lang=js&"
export * from "./QuestionPaperDetail.vue?vue&type=script&lang=js&"
import style0 from "./QuestionPaperDetail.vue?vue&type=style&index=0&id=beea03be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beea03be",
  null
  
)

export default component.exports